import React, { useRef, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { observable, makeAutoObservable } from 'mobx';
import {
    MarketIdWrapper,
    InputMarketWrapper,
    InputMarketId,
    LabelMarketId,
    CopyWrapper,
} from 'src/domains/sportsbook/trading/view/eventDetails/markets/marketsSettings/components/MarketIdComponent.style';
import { MarketId } from 'src_common/common/websocket2/id/WebsocketId';

interface PropsTypes {
    marketId: MarketId;
}

class State {
    @observable copySuccess = false;

    constructor(public readonly marketIdRef: React.RefObject<HTMLInputElement>) {
        makeAutoObservable(this);
    }
    copyToClipboard = (e: React.MouseEvent<HTMLDivElement, MouseEvent>): void => {
        if (this.marketIdRef !== null && this.marketIdRef.current !== null) {
            this.marketIdRef.current.select();
            document.execCommand('copy');
            const target = e.target as HTMLDivElement;
            target.focus();
            this.copySuccess = true;
            setTimeout(() => {
                this.copySuccess = false;
            }, 3200);
        }
    };
}

export const MarketIdComponent = observer(({ marketId }: PropsTypes) => {
    const marketIdRef = useRef<HTMLInputElement>(null);
    const [state] = useState(() => new State(marketIdRef));

    return (
        <MarketIdWrapper>
            <InputMarketWrapper>
                <InputMarketId
                    type='text'
                    ref={state.marketIdRef}
                    name='market-id'
                    id='market-id'
                    placeholder='Market id'
                    defaultValue={marketId.toOldId()}
                />
                <LabelMarketId htmlFor='market-id'>Market ID</LabelMarketId>
            </InputMarketWrapper>
            <CopyWrapper onClick={state.copyToClipboard}>
                {state.copySuccess ? <span>Copied!</span> : <span>Copy</span>}
            </CopyWrapper>
        </MarketIdWrapper>
    );
});
